'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
import React from 'react';
import { findClosestGlyphAvailable, Icon, IconSizeMap } from "../../index.mjs";
export function IconPlaybackSpeed3x(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M8.096 3.627V2.335H.28v1.5h5.278L2.355 6.596l.799 1.252c.003-.001.024-.009.067-.018.048-.01.107-.02.175-.028a3.86 3.86 0 0 1 .247-.02l.15-.012c.956-.083 1.602.17 2.001.525.403.36.631.89.631 1.508 0 1.071-.953 1.91-2.298 1.91-1.415 0-2.345-1.026-2.444-2.15l-1.495.132c.165 1.857 1.707 3.517 3.939 3.517 1.896 0 3.798-1.257 3.798-3.409 0-.993-.373-1.95-1.133-2.628-.488-.434-1.105-.727-1.823-.852l3.127-2.696zm7.213 4.786-1.97 1.97 1.97 1.97-1.061 1.06-1.97-1.97-1.97 1.97-1.06-1.06 1.97-1.97-1.97-1.97 1.06-1.06 1.97 1.969 1.97-1.97 1.06 1.061z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M13.805 5.761V4H2v2h8.465l-5.197 4.48 1.065 1.67a1.77 1.77 0 0 1 .414-.082c.153-.018.27-.026.389-.034l.222-.016c1.495-.13 2.525.263 3.171.84.651.58 1.014 1.433 1.014 2.415 0 1.743-1.55 3.066-3.661 3.066-2.244 0-3.726-1.63-3.884-3.42l-1.992.176c.245 2.768 2.542 5.243 5.876 5.243 2.845 0 5.661-1.88 5.661-5.065 0-1.483-.557-2.905-1.683-3.909-.793-.706-1.819-1.163-3.029-1.315l4.974-4.288zm9.691 8.071-2.543 2.543 2.543 2.542-1.415 1.415-2.542-2.543-2.543 2.543-1.414-1.415 2.542-2.543-2.542-2.542 1.414-1.415 2.543 2.543 2.542-2.543 1.415 1.415z\'/>'
  }];
  var iconSizeValue = props.size ? IconSizeMap[props.size] : props.iconSize;
  var closestSize = findClosestGlyphAvailable(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconPlaybackSpeed3x is deprecated and will be archived soon. Use IconPlaybackSpeed3x instead.
 */
export function Experimental__IconPlaybackSpeed3x(props) {
  return /*#__PURE__*/React.createElement(IconPlaybackSpeed3x, props);
}